import React from "react";
import { IconCheckBold, IconPeopleProjects, IconXBorder } from "../../../../../icons";
import { convertDate } from "../../../../../libs/dateUtils";

export default function RightScreen({ projects, handleClickProject }) {
  function Header(props) {
    const project = props?.project;
    return (
      <div className="p-5">
        <div className="h-20 flex w-full justify-between">
          <div className="justify-center items-center">
            <span
              className={`${
                (project?.status === "Concluído" && "w-auto p-4 text-blueSky bg-blue-100") ||
                (project?.status === "Ativo" && "w-auto p-4 text-green-600 bg-green-100") ||
                (project?.status === "Cancelado" && "w-auto p-4 text-red-600 bg-red-100")
              }  h-10 items-center justify-center rounded-md text-2xl font-semibold font-new-source-sans-pro`}
            >
              {project?.status}
            </span>
          </div>
          <span className="flex justify-end">
            {project?.img && <img src={project?.img} className="w-20 h-20 rounded-full justify-end border border-gray-100 shadow" />}
          </span>
        </div>
        <h2 className="limit-10-char font-familyRoboto text-3xl font-bold mt-3">{project?.name}</h2>
      </div>
    );
  }

  function Body(props) {
    const project = props?.project;

    function getDateConverted(date) {
      if (!date) return "sem data informada!";
      return "em " + convertDate(date);
    }

    function RenderStatus() {
      if (project?.status === "Ativo") {
        return (
          <div className="users-in-project justify-center items-center font-medium text-2xl font-new-source-sans-pro">
            {IconPeopleProjects} Profissionais no projeto{" "}
            <span className="font-familyRoboto justify-center text-blueDark bg-blue-100 w-8 h-8 items-center rounded-full mx-3">
              {project?.collaborators}
            </span>
          </div>
        );
      }
      if (project?.status === "Cancelado") {
        return (
          <div className="flex justify-center items-center content-center text-center font-medium text-2xl font-new-source-sans-pro flex-nowrap mx-2">
            <span className="mb-2 mr-2 w-10 h-10 bg-red-100 rounded-full justify-center items-center"> {IconXBorder}</span>
            <span className="w-80">Esse projeto foi cancelado {getDateConverted(project?.endDate)}</span>
          </div>
        );
      }
      if (project?.status === "Concluído") {
        return (
          <div className="justify-center items-center content-center text-center font-medium text-2xl font-new-source-sans-pro flex-nowrap mx-2">
            <span className="mb-2 mr-2 w-10 h-10 bg-blue-100 rounded-full justify-center items-center"> {IconCheckBold}</span>
            <span className="w-80">Esse projeto foi concluído {getDateConverted(project?.endDate)}</span>
          </div>
        );
      }
    }
    return (
      <div className="flex flex-col justify-around h-60 p-1">
        <div className="w-full flex justify-between flex-row">
          <span className="justify-center items-center m-3 text-3xl font-familyRobotoo font-bold text-primary">Horas trabalhadas</span>
          <span className="w-auto p-3 m-2 justify-end items-center rounded-md font-new-source-sans-pro text-2xl font-bold bg-blueSky text-white">
            {project?.hoursWorkedWeek}
          </span>
        </div>
        <RenderStatus />
      </div>
    );
  }

  return (
    <div className="min-w-70% justify-center items-center flex-wrap gap-8 min-h-75vh">
      {projects?.map((project) => {
        return (
          <div
            onClick={() => handleClickProject(project?.id)}
            className="w-300px h-270px shadow cursor-pointer rounded-xl bg-white duration-300 hover:ease-in filter hover:brightness-75"
            key={project?.id}
          >
            <div className="h-4 bg-primary rounded-t-xl" />
            <Header project={project} />
            <hr className="border border-background" />
            <Body project={project} />
          </div>
        );
      })}
      {!projects?.length && (
        <h3 className="font-new-source-sans-pro font-bold justify-center items-center text-center text-4xl text-textPrimary">
          Esse cliente não está conectado a nenhum projeto, <br /> ou, <br /> ele não possui projetos ainda!
        </h3>
      )}
    </div>
  );
}
